(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-jersey-construction-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rrConstructionGuideInit) return;
    window.__rrConstructionGuideInit = true;
    function selectTab(tab, focus) {
      var guide = tab.closest('[data-rr-construction-guide]');
      if (!guide) return;
      guide.querySelectorAll('[data-rr-construction-tab]').forEach(function (button) {
        var active = button === tab;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      guide.querySelectorAll('[data-rr-construction-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.rrConstructionPanel !== tab.dataset.rrConstructionTab;
      });
      if (focus) tab.focus();
    }
    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var tab = event.target.closest('[data-rr-construction-tab]');
      if (tab) selectTab(tab, false);
    });
    document.addEventListener('keydown', function (event) {
      if (!(event.target instanceof Element)) return;
      var tab = event.target.closest('[data-rr-construction-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      var tabs = Array.from(tab.closest('[data-rr-construction-guide]').querySelectorAll('[data-rr-construction-tab]'));
      var index = tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      event.preventDefault();
      selectTab(tabs[index], true);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
